interface Props {
  icon: string;
  alt: string;
}

export default function IconComponent(props: Props) {
  return <img src={props.icon} alt={props.alt} />;
}
